import { Component } from '@angular/core';
import {OnInit} from '@angular/core';

declare var $ : any;
@Component({ 
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit
 {
    title = 'app';
    logidin = true;
    showLoader : boolean;
    
    constructor(){}

    loginChange(data)
    {
      if(!data)
      {
        this.logidin=false;
      }

      else
      {
        this.logidin=true;
      }
    }

    ngOnInit()
    {
      let accessToken = localStorage.getItem("accessToken");
      if(accessToken != 'null' && accessToken != "" && typeof accessToken != 'undefined')
      {
        this.logidin = false;
      }
    }
 }



// WEBPACK FOOTER //
// ./src/app/app.component.ts